import script from "./BetBoosterCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BetBoosterCard.vue?vue&type=script&setup=true&lang=js"

import "./BetBoosterCard.vue?vue&type=style&index=0&id=51b19889&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51b19889"]])

export default __exports__